module.exports = __webpack_public_path__ + "img/kefu.8f3ee0ee.gif";